import { useEffect, useState } from 'react';
import { useParams } from "react-router-dom";
import "./user.css";
import { Typography } from 'antd';
import { fetchBranch } from '../apis/branchApi';
import NextSessions from '../components/nextSessions/nextSessions';
import HighlightSection from '../components/highlightSection/HighlightSection';
import Features from '../enums/features';
import WrappedTeaserCard from '../components/WrappedTeaserCard';
import { jwtDecode } from 'jwt-decode';

const { Title } = Typography;

const Home = () => {
  const { user_id } = useParams(); // Extraer el parámetro `user_id` de la URL.
  const [branch, setBranch] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [isWrappedFeatureEnable, setIsWrappedFeatureEnable] = useState(false);
  const [loggedInUserId, setLoggedInUserId] = useState(null);

  useEffect(() => {
    const init = async () => {
      try {
        setBranch(await fetchBranch());
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    }
    init();
  }, [user_id]);

  useEffect(() => {
    const access_token = localStorage.getItem('access_token');
    const decodedToken = jwtDecode(access_token);
    const loggedUserId = decodedToken.sub;
    setLoggedInUserId(loggedUserId);
    const features = JSON.parse(localStorage.getItem('user_features') || '{}');
    const yearWrapped = features[Features.YEAR_WRAPPED] || false;
    setIsWrappedFeatureEnable(yearWrapped);
  }, []);

  if (loading) return <p>Cargando...</p>;
  if (error) return <p>Error: {error}</p>;

  return (
    <div className='mobile-block centered-container m-auto'>
      <Title level={3}>{branch.holding_name}</Title>
      { isWrappedFeatureEnable && (
        <WrappedTeaserCard userId={loggedInUserId} year={2025} />
      )}
      <HighlightSection />
      <NextSessions />
    </div>
  );
};

export default Home;
